import React, { Suspense } from "react";
import { useOutletContext } from "react-router-dom";

import useBreadcrumbs from "components/Breadcrumbs/useBreadcrumbs";
import NotFoundPage from "components/error/NotFoundPage";
import PageLoading from "components/loading/PageLoading";

import { IntegrationView } from "../types";

const IntegrationsGroup = () => {
  const { integration } = useOutletContext<{ integration: IntegrationView }>();

  useBreadcrumbs([
    {
      title: "Integrations",
      link: "/integrations",
    },
    {
      title: integration.name,
    },
  ]);

  if (!integration?.hasViewScreen) {
    return <NotFoundPage />;
  }

  const GroupPage = React.lazy(integration.page);
  return (
    <Suspense fallback={<PageLoading />}>
      <GroupPage />
    </Suspense>
  );
};

export default IntegrationsGroup;
